import {Observable} from "rxjs";
import {ParteDetallsList} from "@app/core/part/domain/part";

export abstract class GetPartsWebService {
  abstract execute(partIDs: number[]): Observable<ParteDetallsList>;
}
